$(function () {
    const altText = "エマジェンでお困りなことはありませんか？エマジェンの使い方や業者のさがし方、複雑な搬送案件など、お気軽にお問い合わせくださいませ。電話番号 03-5842-1190";
    function spMouse() {
        $('.js-spMenu-banner').append('<img src="/img/header/sp_banner_mouse.png?ver1" alt="'+ altText +'">');
    }
    function mouse(banner) {
        $(banner).append('<picture class="js-footer-banner"><source srcset="/img/header/footer_banner_mouse_sm.png?ver1" media="(max-width: 575px)"><img src="/img/header/footer_banner_mouse.png?ver1" alt="'+ altText +'"></picture>');
    }
    function spTouch() {
        $('.js-spMenu-banner').append('<a href="tel:03-5842-1190"><img src="/img/header/sp_banner_touch.png?ver1" alt="'+ altText +'"></a>');
    }
    function touch(banner) {
        $(banner).append('<a href="tel:03-5842-1190"><picture class="js-footer-banner"><source srcset="/img/header/footer_banner_touch_sm.png?ver1" media="(max-width: 575px)"><img src="/img/header/footer_banner_touch.png?ver1" alt="'+ altText +'"></picture></a>');
    }
    if(navigator.userAgent.match(/(Mac OS|iPad)/i) && !navigator.userAgent.match(/(iPhone|iPod)/i) ) {
        // imac、mac pro、mac air、iPadの場合
        spMouse();
        mouse('.js-footer-banner');
        mouse('.js-movie-banner');
        //  iPhoneとiPodの場合
    }else if(navigator.userAgent.match(/(iPhone|Android)/i)) {
        // iPhone、Androidの場合
        spTouch();
        touch('.js-footer-banner');
        touch('.js-movie-banner');
    }else if(navigator.userAgent.match(/(Android)/i)) {
        //  Androidの場合
        if(navigator.userAgent.match(/(Mobile)/i)) {
            // Androidのスマホの場合
            spTouch();
            touch('.js-footer-banner');
            touch('.js-movie-banner');
        } else {
            // Androidのタブレットの場合
            spMouse();
            mouse('.js-footer-banner');
            mouse('.js-movie-banner');
        }
    } else {
        // PCの場合
        spMouse();
        mouse('.js-footer-banner');
        mouse('.js-movie-banner');
    };
})